/**
 * 教研模块路由：父级 /teaching，教案子路由挂在 /teaching/lesson/*
 */
import type { RouteRecordRaw } from 'vue-router'
import { Permission } from '@/utils/permission'

const teachingChildPermissions = [
  Permission.TEACHING_DESIGN_USE,
  Permission.TEACHING_KB_VIEW,
  Permission.TEACHING_KB_MANAGE,
  Permission.TEACHING_GRAPH_VIEW,
  Permission.TEACHING_GRAPH_EDIT,
  Permission.TEACHING_GRAPH_MANAGE,
]

const teachingRoutes: RouteRecordRaw[] = [
  {
    path: 'teaching',
    name: 'Teaching',
    meta: {
      titleKey: 'menu.teaching',
      title: '协同教研',
      requiresAuth: true,
      icon: 'BookOutlined',
      permissions: teachingChildPermissions,
    },
    children: [
      {
        path: 'lesson/workspace',
        name: 'TeachingLessonWorkspace',
        component: () => import('@/modules/teaching/views/lesson-workspace.vue'),
        meta: {
          titleKey: 'menu.teachingLesson',
          title: '教案设计',
          requiresAuth: true,
          permissions: [Permission.TEACHING_DESIGN_USE],
          icon: 'FileTextOutlined',
          breadcrumb: true,
        },
      },
      {
        path: 'lesson/design/:id',
        name: 'TeachingLessonDesign',
        component: () => import('@/modules/teaching/views/lesson-design.vue'),
        meta: {
          title: '课程设计',
          requiresAuth: true,
          permissions: [Permission.TEACHING_DESIGN_USE],
          hidden: true,
          breadcrumb: true,
        },
      },
      {
        path: 'lesson/plan/:id',
        name: 'TeachingLessonPlan',
        component: () => import('@/modules/teaching/views/lesson-plan.vue'),
        meta: {
          title: '标准教案',
          requiresAuth: true,
          permissions: [Permission.TEACHING_DESIGN_USE],
          hidden: true,
          breadcrumb: true,
        },
      },
      {
        path: 'lesson/ppt-outline/:id',
        name: 'TeachingLessonPptOutline',
        component: () => import('@/modules/teaching/views/ppt-outline.vue'),
        meta: {
          title: 'PPT大纲',
          requiresAuth: true,
          permissions: [Permission.TEACHING_DESIGN_USE],
          hidden: true,
          breadcrumb: true,
        },
      },
      {
        path: 'lesson/lecture-notes/:id',
        name: 'TeachingLessonLectureNotes',
        component: () => import('@/modules/teaching/views/lecture-notes.vue'),
        meta: {
          title: '讲稿',
          requiresAuth: true,
          permissions: [Permission.TEACHING_DESIGN_USE],
          hidden: true,
          breadcrumb: true,
        },
      },
      {
        path: 'lesson/results/:id',
        name: 'TeachingLessonResults',
        component: () => import('@/modules/teaching/views/lesson-results.vue'),
        meta: {
          title: '教案结果',
          requiresAuth: true,
          permissions: [Permission.TEACHING_DESIGN_USE],
          hidden: true,
          breadcrumb: true,
        },
      },
      {
        path: 'knowledge',
        name: 'TeachingKnowledge',
        component: () => import('@/modules/teaching/views/knowledge.vue'),
        meta: {
          titleKey: 'menu.teachingKnowledge',
          title: '知识库管理',
          requiresAuth: true,
          permissions: [Permission.TEACHING_KB_VIEW, Permission.TEACHING_KB_MANAGE],
          icon: 'DatabaseOutlined',
          breadcrumb: true,
        },
      },
      {
        path: 'graph',
        name: 'TeachingGraph',
        component: () => import('@/modules/teaching/views/graph.vue'),
        meta: {
          titleKey: 'menu.teachingGraph',
          title: '专业图谱管理',
          requiresAuth: true,
          permissions: [
            Permission.TEACHING_GRAPH_VIEW,
            Permission.TEACHING_GRAPH_EDIT,
            Permission.TEACHING_GRAPH_MANAGE,
          ],
          icon: 'ApartmentOutlined',
          breadcrumb: true,
        },
      },
    ],
  },
]

export default teachingRoutes
